import { useEffect, useState } from 'react'
import { Alert } from './components/Alert'
import { registerRateLimitHandler } from '@/data/rateLimitEvents'

/**
 * OI-C49's chosen shape: one simple global banner, same treatment whether the waiting call came
 * from a form submit or a background screen load — mounted once, as a sibling of the router
 * (`main.tsx`), not per-screen, since `data/rateLimitEvents.ts` is itself process-wide.
 *
 * No `data-cmp` — a plain, uncatalogued fixed-position wrapper, the same shape as
 * `AuthPageShell.tsx`'s own root; kept out of `src/components/` so `data-cmp-required` (scoped
 * there — process/01-UI-CONTRACT.md §2 rule 2) does not ask it to carry a catalogue entry this
 * pass's own addition never had. The `Alert` inside it is the catalogued piece.
 */
export function RateLimitBanner() {
  const [waiting, setWaiting] = useState(false)

  useEffect(() => {
    registerRateLimitHandler(setWaiting)
    return () => registerRateLimitHandler(undefined)
  }, [])

  if (!waiting) return null

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999 }}>
      <Alert variant="info">Please wait, retrying…</Alert>
    </div>
  )
}
